<template>
  <v-container>
    <v-card>
      <v-card-title>
        Add position
        <v-icon right>fa-map-marker-alt</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          From main menu: Pilots or on change status to
          <v-chip color="orange" small>LANDED</v-chip>.
          <kbd>See previous help "Sign In - Landed - Exit"</kbd>
        </p>
        <v-row>
          <v-col cols="6"> </v-col>
        </v-row>
        <p>
          <strong>
            1: Zoom to your location (or use Geolocation).
            <kbd>See below "Using Geolocation"</kbd>
            <!-- <v-chip x-small color="primary">ADD POSITION</v-chip>button. -->
          </strong>
        </p>
        <p><strong>2: Save position.</strong></p>
        <v-row>
          <v-col cols="6">
            <p>
              <v-icon x-small>fa-lightbulb</v-icon>
              <i
                >Use the map at Main menu "Box Map" to see where other pilots
                are.</i
              >
            </p>
          </v-col>
        </v-row>
        <p>To add a new position - just repeat the steps above.</p>
      </v-card-subtitle>
    </v-card>
    <v-card>
      <v-card-title>
        Using Geolocation
        <v-icon right>fa-smile-wink</v-icon>
      </v-card-title>
      <v-card-subtitle>
        <p>
          If you are not quite sure or don't know where you are - you can try
          the Geolocation service.
        </p>
        <p>
          Geolocation uses different sources to decide your position. First of
          all the GPS in your mobile device. To enhance the precision, open a
          mobile app which uses GPS, for instance Google map or the Help 113 app
          in advance. PG Box is a Web app - so it depends on the browser app you
          are using. Usually you will be asked to allow pgbox to use
          geolocation. You can set the behaviour "ask/allow/deny" from your
          mobiles settings menu.
        </p>
        <v-img
          :src="AddPosHelp5"
          height="300px"
          aspect-ratio="1"
          contain
        ></v-img>

        <p>
          <strong>1: Open an app using GPS. For instance Google Map.</strong>
        </p>
        <p>
          <strong>2: Push the Geolocation button.</strong>
          <v-chip small>
            <v-icon x-small color="orange">fa-map-marker</v-icon>
          </v-chip>
        </p>
        <p>
          <i
            >The browser app will first ask for permission to use
            Geolocation.</i
          >
        </p>
        <p>
          <v-icon x-small>fa-lightbulb</v-icon>
          <i
            >The location service depend on wich browser app you use and the
            location settings in the app.</i
          >
        </p>
        <p><strong> 3: Zoom, adjust to your probable position. </strong></p>
        <!-- <p><strong>4: Double clisk in the map.</strong></p> -->
        <p><strong>4: Save position.</strong></p>
      </v-card-subtitle>
    </v-card>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      //   HelpLsb1: require("@/assets/HelpLsb1.png"),
      //   AddPosHelp1: require("@/assets/AddPosHelp1.png"),
      //   AddPosHelp2: require("@/assets/AddPosHelp2.png"),
      //   AddPosHelp3: require("@/assets/AddPosHelp3.png"),
      //   AddPosHelp4: require("@/assets/AddPosHelp4.png"),
      AddPosHelp5: require("@/assets/AddPosHelp5.png"),
    };
  },
};
</script>
